import { render, staticRenderFns } from "./face-selection.vue?vue&type=template&id=76fcee7c&scoped=true&"
import script from "./face-selection.vue?vue&type=script&lang=ts&"
export * from "./face-selection.vue?vue&type=script&lang=ts&"
import style0 from "./face-selection.vue?vue&type=style&index=0&id=76fcee7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fcee7c",
  null
  
)

export default component.exports